import { id } from 'date-fns/locale';
import { ApolloClient } from '@apollo/client';
import gql from 'graphql-tag';

export class CollectionLineInput {
  id: number;
  aa: number;
  materialId: number;
  qty: number;
  netWeight: number;
  finDispNote: string;
  jobtypeId: number;

  constructor() {
    // Initialize properties so Object.keys() can detect them
    this.id = undefined;
    this.aa = undefined;
    this.materialId = undefined;
    this.qty = undefined;
    this.netWeight = undefined;
    this.finDispNote = undefined;
    this.jobtypeId = undefined;
  }
}
export class CollectionPoint {
  id: number;
  name: string;
  addressLine1: string;
  addressLine2: string;
  addressArea: string;
  addressCity: string;
  addressDistrict: string;
  contactPerson: string;
  phone: string;
  profession: {
    name: string;
    id: number;
  };
}
export class CollectorInput {
  id: number;
  name: string;
}
export class FormInput {
  id: number;
  seriesId: number;
  codeNumber: number;
  code: string;
  dateCollected: string;
  collectorId: number;
  colpointContactPerson: string;
  isActive: boolean;
  collectionPointId: number;
  wastereceptionpointId: number;
  routeLineId: number;
  finDispNote: string;
  collectionLines: CollectionLineInput[];

  constructor() {
    this.id = undefined;
    this.seriesId = undefined;
    this.codeNumber = undefined;
    this.code = undefined;
    this.dateCollected = undefined;
    this.collectorId = undefined;
    this.colpointContactPerson = undefined;
    this.isActive = undefined;
    this.collectionPointId = undefined;
    this.wastereceptionpointId = undefined;
    this.routeLineId = undefined;
    this.finDispNote = undefined;
    this.collectionLines = undefined;
  }
}

export const gqlGetQuery = gql`
  query getCollections($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollections(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        code
        seriesId
        codePrefix
        codeNumber
        dateCollected
        collectionPointId
        collectorId
        wastereceptionpointId
        legacyAppId
        recordDate
        isActive
        firstDate
        lastDate
        finDispNote
        firstUser
        lastUser
        collectionpoint {
          id
          name
          addressLine1
          addressLine2
          addressArea
          addressCity
          addressDistrict
          postalCode
          phone
        }
        collector {
          id
          name
        }
        wastereceptionpoint {
          id
          name
        }
        collectionLines {
          id
          aa
          materialId
          finDispNote
          qty
          netWeight
          jobtypeId
          jobtype {
            id
            description
          }
          material {
            id
            name
          }
        }
        idocs {
          id
          identificationDocument
        }
      }
      recordCount
    }
  }
`;

export const gqlGetOrderByIdQuery = gql`
  query getCollectionOrderById($id: Int) {
    getCollectionOrderById(id: $id) {
      id
      collectorId
      code
      collector {
        id
        name
      }
      collectionpoint {
        id
        name
        contactPerson
        addressLine1
        addressLine2
        addressArea
        phone
        postalCode
        mobile
        profession {
          id
          name
        }
      }
    }
  }
`;
export const gqlGetMaterialByIdQuery = gql`
  query getMaterialById($id: Int) {
    getMaterialById(id: $id) {
      id
      name
    }
  }
`;
export const gqlGetWastereceptionpointsByCollectorId = gql`
  query getWastereceptionpointsByCollectorId($collectorId: Int!) {
    getWastereceptionpointsByCollectorId(collectorId: $collectorId) {
      id
      name
      code
      isActive
    }
  }
`;
export const getCollectionById = gql`
  query getCollectionById($id: Int) {
    getCollectionById(id: $id) {
      id
      code
      seriesId
      codePrefix
      codeNumber
      vehicleId
      driverId
      collectionOrderId
      dateCollected
      collectionPointId
      colpointContactPerson
      colpointSignFileId
      collectorId
      finDispNote
      dateStorage
      wastereceptionpointId
      legacyAppId
      recordDate
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      collectionpoint {
        id
        name
        companyVat
        companyTaxOffice
        contactPerson
        addressLine1
        addressLine2
        addressArea
        addressCity
        addressNomos
        postalCode
        phone
        mobile
        fax
        profession {
          id
          name
        }
      }
      collector {
        id
        name
      }
      driver {
        id
        name
        notes
      }
      vehicle {
        id
        plateNumber
      }
      wastereceptionpoint {
        id
        name
      }
      collectionLines {
        id
        aa
        materialId
        qty
        finDispNote
        netWeight
        jobtypeId
        jobtype {
          id
          description
        }
        material {
          id
          name
        }
      }
      collectionOrders {
        id
        code
      }
      routeLineId
      routeLine {
        id
        route {
          id
          code
        }
      }
      idocs {
        id
        identificationDocument
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addCollection($data: CollectionInput) {
    addCollection(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateCollection($data: CollectionInput) {
    updateCollection(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteCollection($id: Int) {
    deleteCollection(id: $id)
  }
`;
export const gqlGetCollectionPointById = gql`
  query getCollectionPointById($id: Int!) {
    getCollectionpointById(id: $id) {
      id
      name
      contactPerson
      addressLine1
      addressLine2
      addressArea
      postalCode
      phone
      mobile

      profession {
        id
        name
      }
    }
  }
`;
export const gqlGetCollectorByCollectionPoint = gql`
  query getCollectorByCollectionPoint($collectionPointId: Int!) {
    getCollectorByCollectionPoint(collectionPointId: $collectionPointId) {
      id
      name
    }
  }
`;
